import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass, NgIf } from '@angular/common';

@Component({
  selector: 'app-ranking-filter',
  templateUrl: './rankingFilterButton.component.html',
  styleUrls: ['./rankingFilterButton.component.scss'],
  standalone: true,
  imports: [NgClass, NgIf, TranslateModule],
})
export class RankingFilterButtonComponent {
  @Input() title: string = null;
  @Input() isIcon: string = null;
  @Input() withArrow: boolean;
  @Input() active: boolean = false;
  @Input() dotActive: boolean = false;

  @Output() isActive: EventEmitter<string>;

  constructor() {
    this.isActive = new EventEmitter<string>(null);
  }

  toggleClick() {
    this.active = !this.active;
    this.isActive.emit(this.title);
  }
}
